module.exports = __webpack_public_path__ + "mo/img/07_Creative-Idea.c36a47a4.png";